// src/components/AdminRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { currentUser, userType } = useAuth();

  // Não está autenticado
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Está autenticado mas não tem role admin
  if (userType !== "admin") {
    return <Navigate to="/" replace />;
  }

  // É admin → permite acesso
  return children;
}
